module.exports = __webpack_public_path__ + "9a3f6eda2c0ec8b26c7fde08a00a521e.svg";